//TODO: Fix spacing between .notchTrigger, it fires callout incorrectly sometimes, since the spacing between triggers is different depending on the number of notches.
(function ($) {
    "use strict";
    var sliderCount = 0;
    var notchCallouts = {};
    /* Slider defaults */
    var defaults = {
        customClasses: "",
        notchCount: 4,
        notchWidth: "auto", /* Set if the handle should scale to the relative size of the track � notches */
        handleAnimationTime: 120, /* Time in milliseconds. */
        handleAnimationType: "linear", /* Default to jquerys auto animation type. Options are any available jquery/jquery UI* animation */
        startingNotch: 2,
        notchChange: function (newNotchIndex) { }
    };

    function moveHandle(event, notch, notchIndex, animate) {
        var $this = $(this);
        var settings = $this.data("slider-settings");
        var $handle = $this.find(".handle");

        // If the data model changed somewhere outside sliders while the user is still in the process of sliding,
        // then ignore the moveHandle call to allow the user who is dragging the slider to determine the notch.
        if (!event && $handle.hasClass("draggable")) return;

        $this.data("slider-notch-position", notchIndex);

        if (typeof jQuery.ui === "undefined") {
            //Default to jquerys auto animation type
            settings.handleAnimationType = "linear";
        }
        if (animate === true) {
            $handle.animate({
                left: notch.css("left")
            }, {
                duration: settings.handleAnimationTime,
                easing: settings.handleAnimationType
            });
        } else {
            $handle.css("left", notch.css("left"));
        }

        return notchIndex;
    }

    function closeNotchCallout(notchIndex) {
        var $this = $(this);
        var selectedNotch = $this.find(".notchTrigger").eq(notchIndex);
        if (selectedNotch) {
            /**
             * TODO: [TA60790][SUI-SFS] Replace AngularJS (aka Angular 1.x) sliders - remove Ancestry UI 1.x jQuery logic
             */
            if (typeof ui === 'object' && ui.callout) {
                ui.callout.close();
            } else {
                selectedNotch.callout('close');
            }
        }
    }

    var methods = {};

    methods.init = function(options) {
        var $this = $(this),
            $handle,
            startingNotch,
            settings = $.extend({}, defaults, options);

        var sliderId = "searchSliderWidget" + sliderCount++;
        $this.data("slider-notch-position", 0);
        $this.data("slider-id", sliderId);


        //Determine what the notch length should be based on array or number passed back.
        function initSettings() {
            settings.notchData = settings.notchCount;
            if (typeof settings.notchCount === "object") {
                settings.notchCount = settings.notchCount.length;
            } else if (typeof settings.notchCount === "number") {
                settings.notchCount = settings.notchCount;
            } else {
                console.warn("notchCount must be array or number");
            }
            $this.data("slider-settings", settings);
            return settings.notchCount;
        }

        function createTrack() {
            $this.addClass("sliderDirective");
            return $this.data("slider-track", $("<div class='track'></div>")
                .appendTo($this));
        }

        function createTrackCover() {
            return $this.data("slider-trackCover", $("<div class='trackCover'></div>")
                .appendTo($this));
        }

        function isNotchDataAvailable(i) {
            return typeof settings.notchData[i] !== "undefined"
                && typeof settings.notchData[i].applyFunc !== "undefined"
                && settings.notchData[i] !== null
                && settings.notchData[i].applyFunc !== null;
        }

        function createTriggerNotchesForCallouts() {
            var notchContent = "",
                i,
                label = "",
                notchPosition = 0;
            if (settings.notchCount > 1) {
                //Loop through notch count to determine how far apart to position each notch.
                //Add label for callouts
                for (i = 0; i < settings.notchCount; i++) {
                    if (isNotchDataAvailable(i)) {
                        label = settings.notchData[i].label;
                    }
                    notchContent += '<div class="notchTrigger calloutTriggerNoArrow" style="left:' + notchPosition + '%; width:'
                        + (100 / settings.notchCount) + '%; margin-left:-' + (100 / settings.notchCount / 2) + 'px;" data-callout="' + label + '"></div>';
                    notchPosition += 100 / (settings.notchCount - 1);
                }
            }
            $this.prepend(notchContent);
        }

        function createNotches() {
            var notchContent = "",
                i,
                notchPosition = 0;
            //Set the starting notch, used for determining handle color
            startingNotch = $this.find(".notch:eq(" + settings.startingNotch + ")");
            if (settings.notchCount > 1) {
                //Loop through notch count to determine how far apart to position each notch.
                //Add value and title to the input for use when updating the filters
                for (i = 0; i < settings.notchCount; i++) {
                    notchContent += '<div class="notch vHidden" style="left:' + notchPosition + '%;"></div>';
                    notchPosition += 100 / (settings.notchCount - 1);
                }
            } else {
                $this.css("opacity", "0.5");
                $this.off();
                console.warn("Notch count must be 2 or more");
            }
            return $this.data("slider-notches", $(notchContent)
                .appendTo($this)).first().addClass("notchComp");
        }

        function createHandle() {
            var handleWidth;
            if (settings.notchWidth !== "small") {
                handleWidth = ($this.width() / settings.notchCount + 10);
            } else {
                handleWidth = 23;
            }
            var handleHeight = handleWidth;
            return $this.data("slider-handle", $("<button type='button' class='handle ancBtn tin silver calloutTriggerNoArrow'></button>")
                .css({ "width": handleWidth, "height": handleHeight, "margin-left": -handleWidth / 2 + $(".notch").width() / 2 - 3 + "px" })
                .appendTo($this)
                .data("slider-default-position", settings.startingNotch));
        }

        function initHandlePosition(e) {
            $handle = $this.find(".handle");
            //Should we get the value from settings.startingNotch or data?
            var startingNotchIndex = $handle.data("slider-default-position"),
                notch = $this.find(".notch:eq(" + startingNotchIndex + ")");
            moveHandle.call($this, e, notch, startingNotchIndex, false);
        }

        function initNotchCallout() {
            var $notchTrigger = $this.find(".notchTrigger");
            $notchTrigger.each(function(i) {
                var notch = $notchTrigger.eq(i);
                /**
                 * TODO: [TA60790][SUI-SFS] Replace AngularJS (aka Angular 1.x) sliders - remove Ancestry UI 1.x jQuery logic
                 */
                if (typeof ui === 'object' && ui.callout) {
                    var currentCallout = ui.callout(notch[0], {
                        position: 'top',
                        content: notch.data('callout'),
                        calloutClasses: 'sfsNotchCallout',
                        type: 'hover',
                        calloutStyle: 'light'
                    });
                    notchCallouts[currentCallout.id] = currentCallout;
                } else {
                    notch.callout({
                        position: 'top',
                        align: 'center',
                        content: notch.data('callout'),
                        calloutClasses: 'sfsNotchCallout',
                        type: 'hover',
                        style: 'light'
                    });
                }
            });
        }

        function renderHandleCallouts() {
            if (settings.useCallouts === true) {

                //Set delay to allow callouts to initialize
                setTimeout(function() {
                    initNotchCallout();
                }, 10);

                $handle
                    .on('touchend.' + sliderId + ' mouseleave.' + sliderId, function() {
                        var currentNotchIndex = $this.data("slider-notch-position");
                        closeNotchCallout.call($this, currentNotchIndex);
                    });
            }
        }

        function setHandleColor() {
            var notchPosition = $this.data("slider-notch-position");
            if (settings.startingNotch === notchPosition && $handle.hasClass("green")) {
                $handle.removeClass("green").addClass("silver");
            } else if (settings.startingNotch !== notchPosition && $handle.hasClass("silver")) {
                $handle.removeClass("silver").addClass("green");
            }
        }

        function renderHandleBinding() {
            //Slider drag
            $handle
                .on('touchstart.' + sliderId + ' mousedown.' + sliderId, function(e) {
                    $(this).addClass("draggable");
                    $this.find(".track").show();
                });
        }

        function addHoverClass() {
            var $track = $this.find(".track");
            if (!$track.hasClass("hover")) {
                $track.addClass("hover");
            }
        }

        function addNotchClass() {
            var $notch = $this.find(".notch");
            if (!$notch.hasClass("hover")) {
                $notch.addClass("hover");
            }
        }

        function renderSliderBindings() {
            //Slider drag
            renderHandleBinding();
            //Slider release
            $("body")
                .on('touchend.' + sliderId + ' mouseup.' + sliderId, function(e) {
                    setHandleColor();
                    $this.find(".notch").addClass("vHidden");
                    $handle.removeClass("draggable");
                    $handle.stop(true, true);
                    $this.find(".track").removeClass("hover");
                })
                .on('touchstart.' + sliderId + ' touchmove.' + sliderId + ' mousemove.' + sliderId, function(e) {
                    if ($handle.hasClass("draggable")) {
                        var notchIndex = getNotchIndexForEvent(e);
                        var currentNotchIndex = $this.data("slider-notch-position");
                        if (currentNotchIndex !== notchIndex) {
                            var notch = $this.find(".notch:eq(" + notchIndex + ")");
                            moveHandle.call($this, e, notch, notchIndex, false);
                            if (settings.notchCount === 2) {
                                renderHandleBinding();
                            }
                            addHoverClass();
                        }
                    }
                    if ($handle.hasClass("draggable")) {
                        $this.find(".track").show();
                        $this.find(".notch").removeClass("vHidden");
                    }
                });
            $this
                //Slider hover track
                .on('mouseover.' + sliderId, function() {
                    $this.find(".track").show();
                    addHoverClass();
                })
                .on('mouseenter.' + sliderId, function() {
                    if ($handle.hasClass("silver")) {
                        $handle.removeClass("silver").addClass("green");
                    }
                    addHoverClass();
                })
                .on('mouseleave.' + sliderId, function(e) {
                    if (!$handle.hasClass("draggable")) {
                        setHandleColor();
                        $this.find(".track").show();
                        $this.find(".notch").addClass("vHidden");
                        $this.find(".track").removeClass("hover");
                    };
                })
                //Slider hover node
                .on('touchmove.' + sliderId + ' mousemove.' + sliderId, function(e) {
                    var notchIndex = getNotchIndexForEvent(e),
                        selectedNotch = $this.find(".notchTrigger").eq(notchIndex);
                    var notch = $this.find(".notch:eq(" + notchIndex + ")");
                    //Convert string back to int hide all notches and show closest notch.
                    $this.find(".notch").addClass("vHidden");
                    addNotchClass();
                    addHoverClass();
                    notch.removeClass("vHidden");
                   if (typeof ui === 'object' && ui.callout) {
                       notchCallouts[selectedNotch.attr('data-ui-id')].open();
                   } else {
                       selectedNotch.trigger("mouseenter");
                   }
                })
                .on('touchend.' + sliderId, function (e) {
                    var notchIndex = $(this).data("slider-notch-position");
                    var notch = $this.find(".notch:eq(" + notchIndex + ")");
                    addNotchClass();
                    moveHandle.call($this, e, notch, notchIndex, true);
                    setHandleColor();
                })
                .on('click.' + sliderId, function (e) {
                    var notchIndex = getNotchIndexForEvent(e);
                    var notch = $this.find(".notch:eq(" + notchIndex + ")");
                    addNotchClass();
                    moveHandle.call($this, e, notch, notchIndex, true);
                    setHandleColor();
                });
        }

        function getNotchIndexForEvent(e) {
            if (typeof e.originalEvent !== "undefined" && typeof e.originalEvent.touches !== "undefined") {
                e = e.originalEvent.touches[0];
            }
            var pixelsBetweenNotches = ($this.width() / ((settings.notchCount) - 1));
            var cursorLeftOffsetFromSliderBar = e.clientX - $this.offset().left;
            var notchIndex = Math.round(cursorLeftOffsetFromSliderBar / pixelsBetweenNotches);
            if (notchIndex < 0) {
                notchIndex = 0;
            } else if (notchIndex > settings.notchCount - 1) {
                notchIndex = settings.notchCount - 1;
            }
            return notchIndex;
        }

        function setupEventHandlers() {
            $this.on("click." + sliderId + " touchend." + sliderId, function() {
                settings.notchChange($this.data("slider-notch-position"));
            });
            $this.parents("body").bind("mousemove." + sliderId + " touchmove." + sliderId, function() {
                if ($this.find(".handle").hasClass("draggable")) {
                    settings.notchChange($this.data("slider-notch-position"));
                }
            });
        }

        initSettings();
        createTrack();
        createNotches();
        createTriggerNotchesForCallouts();
        createTrackCover();
        createHandle();
        initHandlePosition();
        renderSliderBindings();
        renderHandleCallouts();
        setupEventHandlers();

        $(window).on('resize.' + sliderId, function(e) {
            // When the window resizes widths can change, so the handle needs to be rerendered
            // Note that nothing else needs to be rerendered like notches as they are laid out with percentage based styles.
            var notchIndex = $this.data("slider-notch-position");
            var notch = $this.find(".notch:eq(" + notchIndex + ")");
            moveHandle.call($this, e, notch, notchIndex, false);
        });
    };

    methods.setNotchIndex = function(notchIndex) {
        var notch = $(this).find(".notch:eq(" + notchIndex + ")");
        moveHandle.call($(this), null, notch, notchIndex, false);
    };

    methods.destroy = function() {
        var $this = $(this);
        var $notchTrigger = $this.find(".notchTrigger");
        $notchTrigger.each(function(i) {
            var notch = $notchTrigger.eq(i);
            /**
             * TODO: [TA60790][SUI-SFS] Replace AngularJS (aka Angular 1.x) sliders - remove Ancestry UI 1.x jQuery logic
             */
            if (typeof ui === 'object' && ui.callout) {
                ui.callout(notch[0], {
                    content: ''
                }).destroy();
            } else {
                notch.callout('destroy');
            }
        });
        $this.removeData("slider-settings slider-notch-position slider-track slider-trackCover slider-notches slider-handle slider-default-position");
        var sliderIdNamespace = "." + $this.data('slider-id');
        $('body').off(sliderIdNamespace);
        $(window).off(sliderIdNamespace);
        $this.off(sliderIdNamespace);
        $this.html("");
    }

    $.fn.searchSlider = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.slider');
        }
    };
}(jQuery));
(function () {
    var sliderApp = angular.module('SliderApp', ['sliderWidgetModule', 'SearchFormServiceUI']);

    angular.module('SliderApp').service('metadataService', ['$window', function ($window) {
        return {
            getMetadata: function (domPrefix) {
                domPrefix = domPrefix || 'sfs_';
                var metadata = $window[domPrefix + 'ScopeMetadata'];
                return metadata;
            }
        }
    }]);

    sliderApp.factory('sliderLocalizationService', ['$window', function ($window) {
        if (typeof $window.Ancestry == 'undefined') $window.Ancestry = {};
        if (typeof $window.Ancestry.SFS == 'undefined') $window.Ancestry.SFS = {};
        if (typeof $window.Ancestry.SFS.Strings == 'undefined') $window.Ancestry.SFS.Strings = {};
        return {
            get: function (key) {
                var str = $window.Ancestry.SFS.Strings[key];
                if (str) {
                    for (var i = 1; i < arguments.length; ++i) {
                        var arg = arguments[i];
                        str = str.replace("{" + (i - 1) + "}", arg);
                    }
                    return str;
                }
                // If key was not found, return null
                return null;
            }
        };
    }]);

    //Result returned from the service
    sliderApp.controller('SliderController', [
        '$scope', 'sliderResultsFactory', 'nonSliderDataService', 'sliderLocalizationService', '$window', 'metadataService', 'sfsDataModelProvider', 'submitQueryService',
        function ($scope, sliderResultsFactory, nonSliderDataService, sliderLocalizationService, $window, metadataService, sfsDataModelProvider, submitQueryService) {

            $scope.domPrefix = 'sfs_';
            $scope.editSearch = function () {
                if ($window.TGN && $window.TGN.SM && $window.TGN.SM.ShowRefineSearchT) {
                    TGN.SM.ShowRefineSearchT(false);
                }
                if ($window.ancestry && $window.ancestry.search && $window.ancestry.search.editSearch) {
                    $window.ancestry.search.editSearch();
                }
            }

            $scope.getSliderValue = function (config) {
                if (config.valuePath) {
                    return config.context[config.valuePath];
                } else {
                    return config.computedValue();
                }
            };

            $scope.ShouldDisableUpdateButton = function() {
                return $scope.SliderForm.$invalid || $scope.Url == null || $scope.Url === "";
            };

            $scope.hasLabel = function (config) {
                return config.isNested || (config.label || '').length > 0;
            };

            $scope.submitSearch = function () {
                if ($scope.ShouldDisableUpdateButton()) return;
                submitQueryService.submitSearchQuery($scope.model, metadataService.getMetadata());
            };

            $scope.model = sfsDataModelProvider.getDataModel($scope.domPrefix);
            var originalDataModel = $.extend(true, {}, $scope.model);
            originalDataModel.page.number = 1;
            originalDataModel.page.cursor = null;
            var unchangedQueryString = null;

            var isDebugOnUrlRegex = /(^|&|[?])debug=1($|&)/;
            function getSubmitQueryString(dataModel, forceUseOfPageOne) {
                var queryString = null;
                if (forceUseOfPageOne) {
                    var oldPaging = $scope.model.page;
                    $scope.model.page = { number: 1, cursor: null, size: oldPaging.size };
                    queryString = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults', null).queryString;
                    $scope.model.page = oldPaging;
                } else {
                    queryString = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults', null).queryString;
                }
                if (isDebugOnUrlRegex.test($window.location.search || '')) {
                    queryString += '&debug=1';
                }
                return queryString;
            }

            function updateNavigationUrl() {
                if (unchangedQueryString == null) {
                    unchangedQueryString = getSubmitQueryString(originalDataModel);
                }
                var queryString = getSubmitQueryString($scope.model, true);
                $scope.Url = queryString === unchangedQueryString ? null : '?' + queryString;
            }

            $scope.$watch('model', function() {
                $scope.sliderConfigs = sliderResultsFactory.getProcessedSliderData($scope.model);
                $scope.moreSearchFields = nonSliderDataService.getMoreSearchFieldsData($scope.model, $scope.sliderConfigs);
                $scope.moreSearchFieldsText = sliderLocalizationService.get("moreSearchFields", $scope.moreSearchFields.TotalMemberCount);
                updateNavigationUrl();
            }, true);

            $scope.nestedSliderLabel = sliderLocalizationService.get("InLabelSliderPrefix") + ":";

            //Update Button HREF
            $scope.Url = null;

            // Old Search Simulator Year Values
            $scope.ShouldShowOssYearRange = metadataService.getMetadata().form.type === 'OldSearchSimulator';

            //Collection Select
            $scope.showCollectionPriority = nonSliderDataService.hasCollectionPriority();

            // ****************************************************
            //   More Search Fields (Appears Below Sliders)
            // ****************************************************
            // Expand "More Info" area for manual searches, and collapse for tree searches
            var isNullOrWhitespace = function (str) {
                return str == null || /^ *$/.test(str);
            }
            $scope.moreSearchFieldsExpanded = isNullOrWhitespace($scope.model.treePerson.treeId) || isNullOrWhitespace($scope.model.treePerson.personId);
            $scope.toggleMoreSearchFieldsExpansion = function() {
                $scope.moreSearchFieldsExpanded = !$scope.moreSearchFieldsExpanded;
            };
        }
    ]); // End SlidersController
})();angular.module('SliderApp').service("configValues", ['$window', function ($window) {
    return {
        getMaxSliderCount: function () {
            return ($window.Ancestry && $window.Ancestry.SFS && $window.Ancestry.SFS.MaxSliders) ? $window.Ancestry.SFS.MaxSliders : 10;
        }
    };
}]);
angular.module('SliderApp').factory('sliderResultsFactory', ['sliderLocalizationService', 'configValues', 'sfsLocationExactnessProvider',
    function (localizationService, configValues, sfsLocationExactnessProvider) {

    var isWhitespaceRegex = /^ *$/;
    var cachedConfigs = [];
    var nextEventGroupIndex = {};

    function getProcessedSliderData(model) {
        if (model == null) return [];
        var sliders = getSliderConfigs(model);
        var filteredSliders = getFilteredSliders(model, sliders);
        return filteredSliders;
    };

    function getSliderConfigs(model) {
        var givenNameSlider = getGivenNameSliderConfig(model);
        var surnameSlider = getSurnameSliderConfig(model);
        var sliderConfigs = [];
        if (givenNameSlider) {
            sliderConfigs.push(givenNameSlider);
        }
        if (surnameSlider) {
            sliderConfigs.push(surnameSlider);
        }
        sliderConfigs = sliderConfigs.concat(getEventSliderConfigs(model));
        return sliderConfigs;
    }

    function getSliderConfigFromCacheOrNull(context, valuePath) {
        for (var i = 0; i < cachedConfigs.length; ++i) {
            var sliderConfig = cachedConfigs[i];
            if (sliderConfig.context === context && sliderConfig.valuePath === valuePath) {
                return sliderConfig;
            }
        }
        return null;
    }

    function cacheSliderConfig(sliderConfig) {
        var foundSliderConfig = getSliderConfigFromCacheOrNull(sliderConfig.context, sliderConfig.valuePath);
        if (!foundSliderConfig) {
            cachedConfigs.push(sliderConfig);
        }
    }

    function getEventSliderConfigs(model) {
        var slidersMetadata = getSlidersMetadata(); // collection describing how to find slider data and organize it
        var sliders = [];
        // Traverse all metadata objects to create slider configurations where a value for that type of slider exists
        for (var i = 0; i < slidersMetadata.length; i++) {
            var metadata = slidersMetadata[i];
            var eventContainer = model.events[metadata.eventGroupName];
            eventContainer.instances.forEach(function (event, eventIndex) {
                var dateSliderConfig = getEventDateSliderConfig(event, metadata, eventIndex);
                if (dateSliderConfig) {
                    dateSliderConfig.nestedSliders.length = 0;
                    sliders.push(dateSliderConfig);
                }

                var locationSliderConfig = getEventLocationSliderConfig(event, metadata, eventIndex);
                if (locationSliderConfig) {
                    locationSliderConfig.isNested = false;
                    if (dateSliderConfig) {
                        dateSliderConfig.nestedSliders.push(locationSliderConfig);
                        locationSliderConfig.isNested = true;
                    }
                    sliders.push(locationSliderConfig);
                }
            });
        }
        return sliders;
    };

    function getEventDateSliderConfig(event, metadata, eventIndex) {
        nextEventGroupIndex[metadata.eventGroupName] = nextEventGroupIndex[metadata.eventGroupName] || 0;
        if (event.date.year == null) return null;
        var context = event.date;
        var valuePath = 'year';
        var sliderConfig = getSliderConfigFromCacheOrNull(context, valuePath);
        if (!sliderConfig) {
            var proximity = event.dateProximity;
            var nextId = nextEventGroupIndex[metadata.eventGroupName]++;
            sliderConfig = {
                id: metadata.eventGroupName + 'Year-' + nextId,
                type: metadata.eventGroupName + 'Year',
                eventGroupName: metadata.eventGroupName,
                context: context,
                exactness: proximity,
                valuePath: valuePath,
                label: metadata.label,
                nestedSliders: [],
                notchArray: [
                    {
                        matchFunc: function () { return proximity.year == null; },
                        applyFunc: function () { proximity.year = null; },
                        label: localizationService.get("BroadSearchFilterLabel")
                    },
                    {
                        matchFunc: function () { return proximity.year === 10; },
                        applyFunc: function () { proximity.year = 10; },
                        label: "+/- 10 " + localizationService.get("YearSliderFilterText")
                    },
                    {
                        matchFunc: function () { return proximity.year === 5; },
                        applyFunc: function () { proximity.year = 5; },
                        label: "+/- 5 " + localizationService.get("YearSliderFilterText")
                    },
                    {
                        matchFunc: function () { return proximity.year === 2; },
                        applyFunc: function () { proximity.year = 2; },
                        label: "+/- 2 " + localizationService.get("YearSliderFilterText")
                    },
                    {
                        matchFunc: function () { return proximity.year === 1; },
                        applyFunc: function () { proximity.year = 1; },
                        label: "+/- 1 " + localizationService.get("YearSliderFilterText")
                    },
                    {
                        matchFunc: function () { return proximity.year === 0; },
                        applyFunc: function () { proximity.year = 0; },
                        label: localizationService.get("ExactLabel")
                    }
                ]
            };
            cacheSliderConfig(sliderConfig);
        }
        sliderConfig.eventIndex = eventIndex;
        return sliderConfig;
    };

    function getEventLocationSliderConfig(event, metadata, eventIndex) {
        nextEventGroupIndex[metadata.eventGroupName] = nextEventGroupIndex[metadata.eventGroupName] || 0;
        if (event.location != null && !isWhitespaceRegex.test(event.location)) {
            var context = event;
            var valuePath = 'location';
            var exactness = event.locationExactness;

            var sliderConfig = getSliderConfigFromCacheOrNull(context, valuePath);
            if (!sliderConfig) {
                var nextId = nextEventGroupIndex[metadata.eventGroupName]++;
                sliderConfig = {
                    id: metadata.eventGroupName + 'Place-' + nextId,
                    type: metadata.eventGroupName + 'Place',
                    eventGroupName: metadata.eventGroupName,
                    context: context,
                    exactness: exactness,
                    valuePath: valuePath,
                    label: metadata.label,
                    notchArray: []
                };
                cacheSliderConfig(sliderConfig);
            }
            sliderConfig.eventIndex = eventIndex;

            sliderConfig.notchArray.length = 0;

            var hasGpid = event.gpid != null && !isWhitespaceRegex.test(event.gpid);
            if (!hasGpid) {
                sliderConfig.notchArray.push({
                    matchFunc: function() {
                        return exactness.isExact === false;
                    },
                    applyFunc: function() {
                        exactness.isExact = false;
                        exactness.level = null;
                        exactness.isAdjacent = false;
                    },
                    label: localizationService.get("BroadSearchFilterLabel")
                });
                sliderConfig.notchArray.push({
                    matchFunc: function() { return exactness.isExact === true; },
                    applyFunc: function() {
                        exactness.isExact = true;
                        exactness.level = 0;
                        exactness.isAdjacent = false;
                    },
                    label: localizationService.get("ExactLabel")
                });
            } else {
                sfsLocationExactnessProvider.getPlaceInfoByPrefixMatchingGpid('sfs_', event.location, event.gpid, function(err) {
                    if (err) return;
                    sliderConfig.notchArray.length = 0;
                    var exactnesses = sfsLocationExactnessProvider.getExactnesses('sfs_', event.gpid);
                    function getPlaceNotch(loopExactness) {
                        return {
                            matchFunc: function() {
                                return exactness.level === loopExactness.relativeLevel
                                    && exactness.isAdjacent === loopExactness.isAdjacent;
                            },
                            applyFunc: function() {
                                exactness.isExact = true;
                                exactness.level = loopExactness.relativeLevel;
                                exactness.isAdjacent = loopExactness.isAdjacent;
                            },
                            label: loopExactness.optionString
                        };
                    };

                    sliderConfig.notchArray.push({
                        matchFunc: function () { return exactness.isExact === false; },
                        applyFunc: function() {
                            exactness.isExact = false;
                            exactness.level = null;
                            exactness.isAdjacent = false;
                        },
                        label: localizationService.get("BroadSearchFilterLabel")
                    });
                    for (var i = exactnesses.length - 1; i >= 0; --i) {
                        sliderConfig.notchArray.push(getPlaceNotch(exactnesses[i]));
                    }
                });
            }
            return sliderConfig;
        };
        return null;
    };

    function getFilteredSliders(model, sliders) {
        var filteredSliders = [];               // All sliders to be shown in sorted order
        var optionalSliders = sliders.slice(0); // Collection of optional sliders

        // Remove important sliders from the optional Sliders collection.  Most of these can immediately go in the filteredSliders Array.
        function removeSliderWithNameFromOptionalSlidersArray(fieldName, addToFilteredArray) {
            var sliderFindResult = findSliderWithFieldName(fieldName, optionalSliders);
            if (sliderFindResult != null) {
                if (addToFilteredArray) {
                    filteredSliders.push(sliderFindResult.slider);
                }
                optionalSliders.splice(sliderFindResult.index, 1);
            }
            return sliderFindResult != null ? sliderFindResult.slider : null;
        };
        removeSliderWithNameFromOptionalSlidersArray('SelfGivenName', true);
        removeSliderWithNameFromOptionalSlidersArray('SelfSurname', true);
        removeSliderWithNameFromOptionalSlidersArray('SelfBirthYear', true);
        removeSliderWithNameFromOptionalSlidersArray('SelfBirthPlace', true);
        var group1Length = filteredSliders.length;
        var deathSliderDate = removeSliderWithNameFromOptionalSlidersArray('SelfDeathYear', false);
        var deathSliderLocation = removeSliderWithNameFromOptionalSlidersArray('SelfDeathPlace', false);

        // Sort Optional Sliders by Date.  See Sort Rules
        var eventTypeSortOrder = ["SelfBirth", "SelfMarriage", "SelfResidence", "SelfArrival", "SelfDeparture", "SelfMilitary", "Self", "SelfDeath"];
        optionalSliders.sort(function (slider1, slider2) {
            /**
            * Sort Rules
            *      1.) Sliders with dates are before sliders that do not have dates
            *      2.) Sliders with dates are sorted chronologically lowest to highest (most recent)
            *      3.) Sliders without dates will have their order maintained relative to where they are to each other
            **/
            var date1 = slider1.context[slider1.valuePath];
            var date2 = slider2.context[slider2.valuePath];
            var isSlider1Date = slider1.valuePath === 'year';
            var isSlider2Date = slider2.valuePath === 'year';
            if (isSlider1Date && !isSlider2Date) return -1;  // dates always before non-date sliders
            if (isSlider2Date && !isSlider1Date) return 1;   // dates always before non-date sliders
            if (!isSlider1Date && !isSlider2Date) {
                // Put non-location sliders below location sliders (towards the back of the array).
                var isSlider1Location = slider1.valuePath === 'location';
                var isSlider2Location = slider2.valuePath === 'location';
                if (isSlider1Location && !isSlider2Location) return -1;
                if (!isSlider1Location && isSlider2Location) return 1;
                if (!isSlider1Location && !isSlider2Location) return 0;
                // Group and sort location sliders by event type.
                var slider1EventTypeIndex = $.inArray(slider1.eventGroupName, eventTypeSortOrder);
                var slider2EventTypeIndex = $.inArray(slider2.eventGroupName, eventTypeSortOrder);
                if (slider1EventTypeIndex < slider2EventTypeIndex) return -1;
                if (slider1EventTypeIndex > slider2EventTypeIndex) return 1;
                // Sort sliders within event type groups by index. e.g. residence before residence2, etc...
                if (slider1.eventIndex < slider2.eventIndex) return -1;
                if (slider1.eventIndex > slider2.eventIndex) return 1;
                return 0;
            }
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
            return 0;
        });

        // Put all sliders together in filteredSliders array
        filteredSliders = filteredSliders.concat(optionalSliders);
        if (deathSliderDate != null) filteredSliders.push(deathSliderDate);
        if (deathSliderLocation != null) filteredSliders.push(deathSliderLocation);

        // Find location sliders that have an associated date slider.  Move these together and mark the location
        // slider as nested and update the label.
        for (var i = filteredSliders.length - 1; i >= 0; --i) {
            var slider = filteredSliders[i];
            if (!slider.nestedSliders || slider.nestedSliders.length === 0) continue;
            var parentSliderIndex = $.inArray(slider, filteredSliders);
            var nestedSlidersAdded = 0;
            for (var j = 0; j < slider.nestedSliders.length; ++j) {
                var nestedSlider = slider.nestedSliders[j];
                var foundIndex = $.inArray(nestedSlider, filteredSliders);
                if (foundIndex === -1) continue;
                var foundSlider = filteredSliders.splice(foundIndex, 1)[0];
                filteredSliders.splice(parentSliderIndex + 1 + nestedSlidersAdded, 0, foundSlider);
                ++nestedSlidersAdded;
            }
        }

        // For Tree Searches, limit the number of sliders that are shown
        var isTreeSearch = model.treePerson.treeId != null
            && model.treePerson.treeId.length > 0
            && model.treePerson.personId != null
            && model.treePerson.personId.length > 0;
        if (isTreeSearch) {
            var slidersToRemoveCount = Math.max(filteredSliders.length - configValues.getMaxSliderCount(), 0);
            var arr1 = filteredSliders.slice(0, group1Length);
            var arr2 = filteredSliders.slice(group1Length, group1Length + optionalSliders.length);
            var arr3 = filteredSliders.slice(group1Length + optionalSliders.length);
            var slidersRemovedCount = limitSlidersArray(arr2, slidersToRemoveCount);
            filteredSliders = arr1.concat(arr2).concat(arr3);
            limitSlidersArray(filteredSliders, slidersToRemoveCount - slidersRemovedCount);
        }

        return filteredSliders;
    };

    function limitSlidersArray(sliders, limit) {
        var slidersToRemoveCount = Math.min(sliders.length, limit);
        if (slidersToRemoveCount <= 0 || sliders.length === 0) return 0;
        var startRemoveIndex = sliders.length - slidersToRemoveCount;
        var firstSliderToRemove = sliders[startRemoveIndex];
        if (firstSliderToRemove.isNested) {
            startRemoveIndex--;
            slidersToRemoveCount++;
        }
        sliders.splice(startRemoveIndex, slidersToRemoveCount);
        return slidersToRemoveCount;
    };

    function findSliderWithFieldName(fieldName, sliders) {
        for (var i = 0; i < sliders.length; ++i) {
            if (sliders[i].type === fieldName) {
                return {
                    slider: sliders[i],
                    index: i
                };
            }
        }
        return null;
    };

    function getGivenNameExactnessApplyFunc(options) {
        return function (exactness) {
            exactness.isExact = options.isExact;
            exactness.flags.phonetic = options.phonetic;
            exactness.flags.similar = options.similar;
            exactness.flags.initials = options.initials;
        }
    }

    function getGivenNameSliderConfig(model) {
        var context = model.name;
        var valuePath = "givenName";
        if (context[valuePath] == null || isWhitespaceRegex.test(context[valuePath] || '')) return null;
        var sliderConfig = getSliderConfigFromCacheOrNull(context, valuePath);
        if (sliderConfig) return sliderConfig;

        var exactness = context.givenNameExactness;
        var flags = exactness.flags;
        sliderConfig = {
            id: "Given-Name-Slider",
            type: "SelfGivenName",
            context: context,
            valuePath: valuePath,
            exactness: exactness,
            notchArray: [
                {
                    matchFunc: function () {
                        // Matches when exactness is not specified
                        // All Possible Matches:
                        //     * not exact
                        return exactness.isExact === false;
                    },
                    applyFunc: getGivenNameExactnessApplyFunc({ isExact: false, phonetic: false, similar: false, initials: false }),
                    label: localizationService.get("BroadSearchFilterLabel")
                },
                {
                    matchFunc: function () {
                        // Matches when exact with initials expansion.  Other expansions may additionally be selected.
                        // All Possible Matches:
                        //     * phonetic, similar, initials
                        //     * phonetic, initials
                        //     * similar, initials
                        //     * initials
                        return flags.initials === true;
                    },
                    applyFunc: getGivenNameExactnessApplyFunc({ isExact: true, phonetic: true, similar: true, initials: true }),
                    label: localizationService.get("ExactSimilarSoundsLikeInitialsSliderFilterText")
                },
                {
                    matchFunc: function () {
                        // Matches when exact with phonetic and not initials (initials always matches second slider)
                        // All Possible Matches:
                        //     * phonetic, similar
                        //     * phonetic
                        return flags.phonetic === true;
                    },
                    applyFunc: getGivenNameExactnessApplyFunc({ isExact: true, phonetic: true, similar: true, initials: false }),
                    label: localizationService.get("ExactSoundsLikeSimilarSliderFilterText")
                },
                {
                    matchFunc: function () {
                        // Matches when exact with similar expansion and no other expansions
                        // All Possible Matches:
                        //     * similar
                        return flags.similar === true;
                    },
                    applyFunc: getGivenNameExactnessApplyFunc({ isExact: true, phonetic: false, similar: true, initials: false }),
                    label: localizationService.get("ExactSimilarSliderFilterText")
                },
                {
                    matchFunc: function () {
                        // Matches when exact with no expansions
                        // All Possible Matches:
                        //     * exact (no expansions)
                        return exactness.isExact === true;
                    },
                    applyFunc: getGivenNameExactnessApplyFunc({ isExact: true, phonetic: false, similar: false, initials: false }),
                    label: localizationService.get("ExactLabel")
                }
            ]
        };
        cacheSliderConfig(sliderConfig);
        return sliderConfig;
    };

    function getSurnameExactnessApplyFunc(options) {
        return function (exactness) {
            exactness.isExact = options.isExact;
            exactness.flags.phonetic = options.phonetic;
            exactness.flags.similar = options.similar;
            exactness.flags.soundex = options.soundex;
        }
    }

    function getSurnameSliderConfig(model) {
        var context = model.name;
        var valuePath = 'surname';
        if (context[valuePath] == null || isWhitespaceRegex.test(context[valuePath]|| '')) return null;
        var sliderConfig = getSliderConfigFromCacheOrNull(context, valuePath);
        if (sliderConfig) return sliderConfig;

        var exactness = context.surnameExactness;
        var flags = exactness.flags;
        sliderConfig = {
            id: "Surname-Slider",
            type: "SelfSurname",
            context: context,
            computedValue: function () {
                return (context.surname + ' ' + context.secondSurname).trim();
            },
            exactness: exactness,
            notchArray: [
                {
                    matchFunc: function () {
                        // Matches all expansions that include soundex
                        // All Possible Matches: 
                        //     * phonetic, similar, soundex
                        //     * phonetic, soundex
                        //     * similar, soundex
                        //     * soundex
                        return flags.soundex === true;
                    },
                    applyFunc: getSurnameExactnessApplyFunc({ isExact: true, phonetic: true, similar: true, soundex: true }),
                    label: localizationService.get("BroadSearchFilterLabel")
                },
                {
                    matchFunc: function () {
                        // Matches when exactness is not specified or it is and one of the expansions is 
                        // phonetic without soundex (since soundex would match first slider)
                        // All Possible Matches:
                        //     * not exact
                        //     * phonetic, similar
                        //     * phonetic
                        return exactness.isExact === false || flags.phonetic === true;
                    },
                    applyFunc: getSurnameExactnessApplyFunc({ isExact: true, phonetic: true, similar: true, soundex: false }),
                    label: localizationService.get("ExactSoundsLikeSimilarSliderFilterText")
                },
                {
                    matchFunc: function () {
                        // Matches when exact with similar expansion is selected with no other expansions
                        // All Possible Matches:
                        //     * similar
                        return flags.similar === true;
                    },
                    applyFunc: getSurnameExactnessApplyFunc({ isExact: true, phonetic: false, similar: true, soundex: false }),
                    label: localizationService.get("ExactSimilarSliderFilterText")
                },
                {
                    matchFunc: function () {
                        // Matches when exact is specified with no expansions
                        // All Possible Matches:
                        //     * exact (no expansions)
                        return exactness.isExact === true;
                    },
                    applyFunc: getSurnameExactnessApplyFunc({ isExact: true, phonetic: false, similar: false, soundex: false }),
                    label: localizationService.get("ExactLabel")
                }
            ]
        };
        cacheSliderConfig(sliderConfig);
        return sliderConfig;
    };

    var slidersMetadataStore = null;
    function getSlidersMetadata() {
        if (slidersMetadataStore) return slidersMetadataStore;
        slidersMetadataStore = [
            {
                eventGroupName: "SelfBirth",
                label: localizationService.get("BornSliderPrefixLabel") + ": "
            },
            {
                eventGroupName: "SelfMarriage",
                label: localizationService.get("SliderMarriageLabel") + ": "
            },
            {
                eventGroupName: "SelfResidence",
                label: localizationService.get("ResidenceEventLabel") + ": "
            },
            {
                eventGroupName: "SelfArrival",
                label: localizationService.get("ArrivalEventLabel") + ": "
            },
            {
                eventGroupName: "SelfDeparture",
                label: localizationService.get("DepartureEventLabel") + ": "
            },
            {
                eventGroupName: "SelfMilitary",
                label: localizationService.get("MilitaryEventLabel") + ": "
            },
            {
                eventGroupName: "Self",
                label: localizationService.get("AnyLabelSliderPrefix") + ": "
            },
            {
                eventGroupName: "SelfDeath",
                label: localizationService.get("DeathEventLabel") + ": "
            }
        ];
        // TODO: Add custom events using SFS metadata.  Will have to consult UX
        // TODO: about how to handle long event names.
        return slidersMetadataStore;
    };

    return {
        getProcessedSliderData: getProcessedSliderData,
        isDateSlider: function () { return false; },
        isLocationSlider: function () { return false; }
    };
}]);angular.module('SliderApp').service('nonSliderDataService', ['metadataService', 'sliderLocalizationService', function (metadataService, localizationService) {
    function hasCollectionPriority() {
        var metadata = metadataService.getMetadata();
        return metadata.collectionFocus.isAvailable;
    };

    var isWhitespaceRegex = /^ *$/;
    function isNullOrWhitespace(str) {
        return str == null || isWhitespaceRegex.test(str);
    }

    function getMoreSearchFieldsData(model, sliderConfigs) {
        var metadata = getMoreSearchFieldsMetaData(model);
        var labelGroups = [];

        addEvents(metadata, labelGroups, model, sliderConfigs);
        addFields(metadata, labelGroups);
        addFamily(metadata, labelGroups, model);

        var totalMemberCount = 0;
        $.each(labelGroups, function(labelGroupIndex, labelGroup) {
            totalMemberCount += labelGroup.MemberCount;
        });
        var moreSearchFieldsData = {
            LabelGroups: labelGroups,
            TotalMemberCount: totalMemberCount
        };
        return moreSearchFieldsData;
    };

    function addEvents(metadata, labelGroups, model, sliderConfigs) {
        metadata.events.forEach(function (eventMetadata) {
            var eventContainer = model.events[eventMetadata.eventGroupName] || { instances: [] };
            if (eventContainer.instances.length === 0) return;

            var summary = [];
            eventContainer.instances.forEach(function (event) {
                var isDateRepresentedElsewhere = eventMetadata.dateShownElsewhere || isEventShownAsDateSlider(event, sliderConfigs);
                var date = isDateRepresentedElsewhere ? '' : event.date.year || "";

                var isLocationRepresentedElsewhere = eventMetadata.locationShownElsewhere || isEventShownAsLocationSlider(event, sliderConfigs);
                var location = isLocationRepresentedElsewhere ? '' : event.location || "";

                var summaryEntry = (date + ' ' + location).trim();
                if (!isNullOrWhitespace(summaryEntry)) {
                    summary.push(summaryEntry);
                }
            });
            if (summary.length > 0) {
                labelGroups.push({
                    Label: eventMetadata.label,
                    MemberCount: summary.length,
                    Summary: summary
                });
            }
        });
    };

    function isEventShownAsDateSlider(event, sliderConfigs) {
        for (var i = 0; i < sliderConfigs.length; ++i) {
            var sliderConfig = sliderConfigs[i];
            if (sliderConfig.context === event.date && sliderConfig.valuePath === 'year') {
                return true;
            }
        }
        return false;
    };

    function isEventShownAsLocationSlider(event, sliderConfigs) {
        for (var i = 0; i < sliderConfigs.length; ++i) {
            var sliderConfig = sliderConfigs[i];
            if (sliderConfig.context === event && sliderConfig.valuePath === 'location') {
                return true;
            }
        }
        return false;
    };

    function addFields(metadata, labelGroups) {
        metadata.fields.forEach(function (fieldMetadata) {
            var value = fieldMetadata.getValue != null
                ? fieldMetadata.getValue()
                : fieldMetadata.context[fieldMetadata.valuePath];
            if (isNullOrWhitespace(value)) return;
            labelGroups.push({
                Label: fieldMetadata.label,
                MemberCount: 1,
                Summary: [value]
            });
        });
    };

    function addFamily(metadata, labelGroups, model) {
        metadata.family.forEach(function (familyMetadata) {
            var names = [];
            familyMetadata.relationships.forEach(function (relationship) {
                model.family[relationship].instances.forEach(function (member) {
                    var entry = familyMetadata.skipSurname
                        ? member.givenName.trim()
                        : (member.givenName + ' ' + member.surname + ' ' + member.secondSurname).trim();
                    if (isNullOrWhitespace(entry)) return;
                    names.push(entry);
                });
            });
            if (names.length > 0) {
                labelGroups.push({
                    Label: familyMetadata.label,
                    MemberCount: names.length,
                    Summary: [names.join(', ')]
                });
            }
        });
    };

    var moreSearchFieldsMetaDataStore = null;
    function getMoreSearchFieldsMetaData(model) {
        if (moreSearchFieldsMetaDataStore != null) return moreSearchFieldsMetaDataStore;
        moreSearchFieldsMetaDataStore = {
            events: [
                {
                    label: localizationService.get("AnyLabelSliderPrefix"),
                    eventGroupName: "Self"
                },
                {
                    label: localizationService.get("AlsoLivedInLabel"),
                    eventGroupName: "SelfResidence"
                },
                {
                    label: localizationService.get("MarriageEventLabel"),
                    eventGroupName: "SelfMarriage"
                },
                {
                    label: localizationService.get("ArrivalEventLabel"),
                    eventGroupName: "SelfArrival"
                },
                {
                    label: localizationService.get("DepartureEventLabel"),
                    eventGroupName: "SelfDeparture"
                },
                {
                    label: localizationService.get("MilitaryEventLabel"),
                    eventGroupName: "SelfMilitary"
                }
            ],
            fields: [
                {
                    label: localizationService.get("SlidersAnythingLabel"),
                    context: model.fields.keyword,
                    valuePath: 'value'
                },
                {
                    label: localizationService.get("RaceLabelSliderPrefix"),
                    context: model.fields.SelfRace,
                    valuePath: 'value'
                },
                {
                    label: localizationService.get("GenderLabel"),
                    context: model.fields.SelfGender,
                    getValue: function() {
                        if (model.fields.SelfGender.value === "male") return localizationService.get("Male");
                        if (model.fields.SelfGender.value === "female") return localizationService.get("Female");
                        return null;
                    }
                }
            ],
            family: [
                {
                    label: localizationService.get("ParentsSliderLabel"),
                    relationships: ['father', 'mother']
                },
                {
                    label: localizationService.get("SiblingsSliderLabel"),
                    relationships: ['sibling'],
                    skipSurname: true
                },
                {
                    label: localizationService.get("SpousesSliderLabel"),
                    relationships: ['spouse']
                },
                {
                    label: localizationService.get("ChildrenSliderLabel"),
                    relationships: ['child'],
                    skipSurname: true
                }
            ]
        };

        var metadata = metadataService.getMetadata();
        var knownFields = ['SelfGender', 'SelfRace', 'keyword'];
        Object.keys(metadata.fields).forEach(function(fieldName) {
            if (knownFields.indexOf(fieldName) !== -1) return;
            moreSearchFieldsMetaDataStore.fields.push({
                label: metadata.fields[fieldName].label,
                context: model.fields[fieldName],
                valuePath: 'value'
            });
        });

        var knownEvents = Object.keys(metadata.events);
        Object.keys(metadata.customEvents).forEach(function (eventGroupName) {
            if (knownEvents.indexOf(eventGroupName) !== -1) return;
            var eventGroupMetadata = metadata.customEvents[eventGroupName];
            var hasEitherDateOrLocationLabelNotBoth =
                (eventGroupMetadata.dateLabel && !eventGroupMetadata.locationLabel) ||
                (!eventGroupMetadata.dateLabel && eventGroupMetadata.locationLabel);
            if (hasEitherDateOrLocationLabelNotBoth) {
                moreSearchFieldsMetaDataStore.events.push({
                    eventGroupName: eventGroupName,
                    label: eventGroupMetadata.dateLabel || eventGroupMetadata.locationLabel
                });
            } else {
                moreSearchFieldsMetaDataStore.events.push({
                    eventGroupName: eventGroupName,
                    label: eventGroupMetadata.dateLabel,
                    locationShownElsewhere: true
                });
                moreSearchFieldsMetaDataStore.events.push({
                    eventGroupName: eventGroupName,
                    label: eventGroupMetadata.locationLabel,
                    dateShownElsewhere: true
                });
            }
            
        });

        return moreSearchFieldsMetaDataStore;
    };

    return {
        getMoreSearchFieldsData: getMoreSearchFieldsData,
        hasCollectionPriority: hasCollectionPriority
    };
}]);(function() {
    var sliderModule = angular.module('sliderWidgetModule', []);
    sliderModule.directive('sliderDirective', [function() {
        return {
            scope: {
                sliderName: '@',
                sliderNotches: '=',
                sliderExactness: '=',
                sliderChange: '&'
            },
            link: function(scope, element, attrs) {
                var applySliderValueForNotch = function(notchIndex) {
                    if (notchIndex >= scope.sliderNotches.length || notchIndex < 0) return null;
                    return scope.sliderNotches[notchIndex].applyFunc(scope.sliderExactness);
                };
                var currentNotchIndex = -1;
                function getNotchIndex() {
                    var currentNotch;
                    for (var i = 0; i < scope.sliderNotches.length; i++) {
                        currentNotch = scope.sliderNotches[i];
                        if (currentNotch.matchFunc(scope.sliderExactness)) return i;
                    }
                    return 0;
                };
                function notchChange(newNotchIndex) {
                    currentNotchIndex = newNotchIndex;
                    applySliderValueForNotch(currentNotchIndex);
                    scope.$apply(scope.sliderChange); // Apply so that changes made in sliderChange can be digested.
                };

                var sliderElement = null;
                function setupSlider() {
                    if (sliderElement) {
                        sliderElement.searchSlider('destroy');
                        $(sliderElement).remove();
                    }
                    sliderElement = $('<div />');
                    element.append(sliderElement);
                    currentNotchIndex = getNotchIndex();
                    sliderElement.searchSlider({
                        startingNotch: currentNotchIndex,
                        notchCount: scope.sliderNotches,
                        notchWidth: "small",
                        radioName: scope.sliderName,
                        useCallouts: true,
                        handleAnimationType: "easeOutElastic",
                        handleAnimationTime: 400,
                        notchChange: notchChange
                    });
                };

                setupSlider();

                scope.$watch('sliderNotches.length', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // Setup the slider notches anew.
                        setupSlider();
                    }
                });
                scope.$watch('sliderExactness', function (newValue, oldValue) {
                    currentNotchIndex = getNotchIndex();
                    sliderElement.searchSlider('setNotchIndex', currentNotchIndex);
                }, true);
            }
        };
    }]);
}());